import {
  CertificateRadio,
  CertificateType,
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
} from 'front-office/view-models/document-birth-form';

export const transformCertificateTitle = (item?: CertificateRadio | null): CertificateRadio => {
  let type = '';
  let value = '';

  if (item?.type === CertificateType.nascita) {
    type = 'Nascita';
  }

  if (item?.type === CertificateType.matrimonio) {
    type = 'Matrimonio';
  }

  if (item?.type === CertificateType.morte) {
    type = 'Morte';
  }

  if (item?.type === CertificateType.unioneCivile) {
    type = 'Unione Civile';
  }

  if (item?.type === CertificateType.cittadinanza) {
    type = 'Cittadinanza';
  }

  const isCertificato =
    item?.value === CertificateValueBorn.certificato ||
    item?.value === CertificateValueMarriage.certificato ||
    item?.value === CertificateValueDeath.certificato ||
    item?.value === CertificateValueCivilUnion.certificato ||
    item?.value === CertificateValueCitizenship.certificato;

  if (isCertificato) {
    value = 'Certificato';
  }

  const isCopia =
    item?.value === CertificateValueBorn.copia ||
    item?.value === CertificateValueMarriage.copia ||
    item?.value === CertificateValueDeath.copia ||
    item?.value === CertificateValueCivilUnion.copia ||
    item?.value === CertificateValueCitizenship.copia;

  if (isCopia) {
    value = 'Copia Conforme';
  }

  const isEstratto =
    item?.value === CertificateValueBorn.estratto ||
    item?.value === CertificateValueMarriage.estratto ||
    item?.value === CertificateValueDeath.estratto ||
    item?.value === CertificateValueCivilUnion.estratto ||
    item?.value === CertificateValueCitizenship.estratto;

  if (isEstratto) {
    value = 'Estratto';
  }

  const isEstrattoVienna =
    item?.value === CertificateValueBorn.estrattoVienna ||
    item?.value === CertificateValueMarriage.estrattoVienna ||
    item?.value === CertificateValueDeath.estrattoVienna;

  if (isEstrattoVienna) {
    value = 'Estratto Internazionale Vienna';
  }

  const isEstrattoParigi =
    item?.value === CertificateValueBorn.estrattoParigi ||
    item?.value === CertificateValueMarriage.estrattoParigi ||
    item?.value === CertificateValueDeath.estrattoParigi;

  if (isEstrattoParigi) {
    value = 'Estratto Internazionale Parigi';
  }

  return {
    type,
    value,
  } as CertificateRadio;
};
